import { useTheme } from "@mui/styles";
import tinycolor from "tinycolor2";
const convertColor = (color, defaultColor) => {
    const isValidColor = !!color && tinycolor(color).isValid();
    return isValidColor ? tinycolor(color).toRgbString() : defaultColor;
};
/**
 * Converts color fields inside an object, ensuring they are MUI valid and normalized to an rgb string.
 * Falls back to theme.palette.common.black for invalid values.
 *
 * @param colors An object where values are color strings to be validated/converted.
 * @returns A new object with the same keys but with validated and formatted (for use with MUI) colors.
 */
export const useConvertColors = (colors = {}) => {
    const defaultBlack = useTheme().palette.common.black;
    const updatedColors = {};
    // Add null check for colors
    if (!colors)
        return updatedColors;
    for (const key in colors) {
        if (Object.prototype.hasOwnProperty.call(colors, key)) {
            updatedColors[key] = convertColor(colors[key], defaultBlack);
        }
    }
    return updatedColors;
};
/**
 * A standalone version of the useConvertColors hook that does not depend on the MUI theme.
 * This function can be used outside of a React component context.
 *
 * Converts color fields inside an object, ensuring they are MUI valid and normalized to an rgb string.
 * Falls back to black (#000000) for invalid values.
 *
 * @param colors An object where values are color strings to be validated/converted.
 * @returns A new object with the same keys but with validated and formatted (for use with MUI) colors.
 */
export const convertColors = (colors = {}) => {
    const updatedColors = {};
    // Add null check for colors
    if (!colors)
        return updatedColors;
    for (const key in colors) {
        if (Object.prototype.hasOwnProperty.call(colors, key)) {
            updatedColors[key] = convertColor(colors[key], "#000000");
        }
    }
    return updatedColors;
};
